export var genericTableRowSize;
(function (genericTableRowSize) {
    genericTableRowSize["SMALL"] = "small";
    genericTableRowSize["MEDIUM"] = "medium";
    genericTableRowSize["LARGE"] = "large";
})(genericTableRowSize || (genericTableRowSize = {}));
